import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
export default class TwoFactorCodeInput extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "value", '');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.value = vnode.attrs.initial || '';
  }
  oninput(e) {
    const target = e.target;
    this.value = target.value;

    // Auto-submit when exactly 6 digits are entered.
    if (this.value.length === 6) {
      this.attrs.onComplete(this.value);
    }
  }
  onkeydown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.attrs.onComplete(this.value);
    }
  }
  view() {
    return m("input", {
      type: "text",
      className: "FormControl",
      value: this.value,
      placeholder: this.attrs.placeholder || 'Enter 6-digit code',
      oninput: e => this.oninput(e),
      onkeydown: e => this.onkeydown(e),
      inputmode: "numeric",
      pattern: "[0-9]*",
      autocomplete: "one-time-code"
    });
  }
}
flarum.reg.add('ianm-twofactor', 'forum/components/TwoFactorCodeInput', TwoFactorCodeInput);